import { ChangeEvent, forwardRef, useEffect, useState } from "react";
import { Input, InputProps } from "./input";

export type InputNumberProps = Omit<InputProps, "value" | "onChange" | "defaultValue"> & {
  defaultValue?: number;
  value?: number;
  onChange?: (value: number) => void;
};

export const InputNumber = forwardRef<HTMLInputElement, InputNumberProps>(
  ({ value: _value, onChange: _onChange, defaultValue: _initialValue, ...props }, ref) => {
    const [value, setValue] = useState<string>(_value?.toString() ?? _initialValue?.toString() ?? "");

    useEffect(() => {
      if (_value === undefined || _value === null) {
        return setValue("");
      }
      setValue(_value.toString());
    }, [_value]);

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
      const nextValue = e.currentTarget.value;
      setValue(nextValue);
      const nextNumber = +nextValue;
      if (nextNumber !== _value) {
        _onChange?.(nextNumber);
      }
    };

    return <Input ref={ref} {...props} onChange={onChange} value={value} />;
  },
);
